"use client";

import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";
import { fetcher } from "@/lib/http/fetcher";
import type { Testimonial } from "../../shared/types";

export function useTestimonials() {
  const locale = useLocale();

  return useQuery<Testimonial[]>({
    queryKey: ["testimonials", locale],
    queryFn: () => fetcher<Testimonial[]>(`/${locale}/api/about/testimonials`),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
